import * as React from "react";
import { SectionHeader } from "../SharedComponents";
import { TextBoxEditor } from "../../../../../../../react-core/Html/TextBoxEditor";
import { WizardLinter, EWizardLinterStatus } from "../../../../../../Shared/Process/Process/WizardLinter";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../Shared/Process/Process/ProcessComponent";

interface IAdviserDetailProps extends IProcessComponentProps {
    onAdviserChange: (changes) => void;
}

interface IAdviserDetailState {}

export class AdviserDetail extends ProcessComponent<IAdviserDetailProps, IAdviserDetailState> {
    componentDidMount() {
        super.componentDidMount();
    }

    render() {
        return (
            <>
                {SectionHeader("Adviser details")}

                <WizardLinter status={EWizardLinterStatus.PleaseCheck} enabled={true}>
                    <TextBoxEditor
                        cssWrapper="control-size-430"
                        value={this.props.data}
                        disabled={true}
                        label={"Adviser's name"}
                    />
                </WizardLinter>

                <hr className="mt-0 mb-20" />
            </>
        );
    }
}
